import LeftNav from "../LeftNav";
import "../styles/ImageLabel.css";
import arrow_forward from "../../assests/arrow_forward.png";
import arrow_back from "../../assests/arrow_back.png";
import chevron_down from "../../assests/chevron-down.png";
import { useEffect, useState } from "react";
import urls from "../../api/urls.json";
import { authorizedHttpGet, authorizedHttpPost } from "../../api/httpCalls";
import { useLocation, useNavigate } from "react-router-dom";
import LabelStatsModal from "../modals/LabelStatsModal";
import Loader from '../Loader';

export default function ImageLabel() {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    const accessLevel = localStorage.getItem('accessLevel');
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const [allLabels, setAllLabels] = useState([])
    const [filters, setFilters] = useState([])
    const [selectedFilters, setSelectedFilters] = useState(null)
    const [page, setPage] = useState(null)
    const [selectedFilter, setSelectedFilter] = useState(null)
    const [allImages, setAllImages] = useState([])
    const [conflictedImages, setConflictedImages] = useState([])
    const [imageToShow, setImageToShow] = useState(0)
    const [labels, setLabels] = useState([])
    const [labelsWithNeutralOption, setLabelsWithNeutralOption] = useState(['Background', 'Styling', 'Quality', 'Posture'])
    const [statsModal, setStatsModal] = useState(false)
    const [stats, setStats] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(()=>{
        const mode = ['Manager', 'Admin'].includes(accessLevel)  ? 'Review' : 'Label'
        const defaultFilters = {Gender: 'All', ProfileStatus: 'All', Category: 'All', Remarks: 'All', Mode: mode, page: 1}
        setSelectedFilters(defaultFilters)
        const labels = ['Background', 'Interests', 'Styling', 'Significant moment in life', 'Profession', 'Posture', 'Pets', 'Quality', 'Studio Images', 'Screenshot', 'Highly edited Images']
        setAllLabels(labels)
        const filters = {Gender: ['Male','Female','All'], ProfileStatus:['Approved', 'Disapproved', 'All'], Remarks:['Conflicting', 'All'], Category: [...labels, 'All'], Mode: ['Label', 'Review']}
        setFilters(filters)
    },[])

    useEffect(()=>{
        if (selectedFilters === null) return 
        setIsLoading(true)

        setLabels([])
        removeSelections()
        const filters = selectedFilters['Remarks'] === 'Conflicting' ? {...selectedFilters, Gender: 'All', ProfileStatus: 'All', Category: 'All', Mode: 'Review'} : selectedFilters
        if (JSON.stringify(filters) !== JSON.stringify(selectedFilters)) {
            setSelectedFilters(filters)
        }

        authorizedHttpGet(urls.GET_IMAGES_FOR_LABELLING_HIVE, {...filters, page: 1} )
        .then((response)=>{
            setAllImages(response.data.images)
            setConflictedImages(response.data.conflicting_images)
            setPage(response.data.page)
            setImageToShow(0)
            setPage(response.data.page)
            setStats(response.data.stats)
            setIsLoading(false)
            // setFilters({Gender: ['Male','Female','All'], ProfileStatus:['Approved', 'Disapproved', 'All'], Category:['Category1', 'Category2', 'Category3']})
        })
        .catch((error)=>{
            console.log(error)
        })

    },[selectedFilters])

    useEffect(()=>{
        if (selectedFilters === null) return;
        if (selectedFilters['Mode'] === 'Label' && page <= 1) return;

        setIsLoading(true)
        authorizedHttpGet(urls.GET_IMAGES_FOR_LABELLING_HIVE, {...selectedFilters, page})
        .then((response)=>{
            setAllImages(response.data.images)
            setConflictedImages(response.data.conflicting_images)
            setImageToShow(0)
            setIsLoading(false) 
        })
        .catch((error)=>{
            console.log(error)
        })
    },[page])

    const removeSelections = () =>{
        Array.from(document.getElementsByClassName('radioButton')).forEach((element)=>{
            element.classList.remove('selectedRadioButton')
        })
        Array.from(document.getElementsByClassName(`selection`)).forEach((element)=>{
            element.classList.add('hidden')
        })
    }
 
    useEffect(()=>{
        if (labels.length < 1) return ;

        Array.from(document.getElementsByClassName('radioButton')).forEach((element)=>{
            element.classList.remove('selectedRadioButton')
        })
        Array.from(document.getElementsByClassName(`selection`)).forEach((element)=>{
            element.classList.add('hidden')
        })

        if (labels[allImages[imageToShow].id]) {
            const existingLabelForImage = labels[allImages[imageToShow].id]
            Array.from(allLabels).forEach((label)=>{
                const selectedValues = existingLabelForImage[label]
                if(selectedValues) {
                    Object.keys(selectedValues).forEach((selection)=>{
                    if (existingLabelForImage[label][selection]) {
                        document.getElementById(`${label}_${selection}`).classList.add('selectedRadioButton')
                        document.getElementById(`selected${label}${selection}`).classList.remove('hidden')
                    }
                }) 
            }
        })

        const nextImageArrow = document.getElementById('nextImageArrow')
        Object.keys(labels[allImages[imageToShow].id]).length === allLabels.length ?  nextImageArrow.classList.remove('unclickable') : nextImageArrow.classList.add('unclickable')
        }
    },[imageToShow])

    const handleFilter = (event)=> {
        selectedFilter === event.target.id ? setSelectedFilter(null) : setSelectedFilter(event.target.id)
    }

    const handleLeftNavAppChange = (name) => {
        setAppName(name)
    };

    const handlePreviousImage = () => {

        document.getElementById('nextImageArrow').classList.remove('hidden')
        if (imageToShow === 0) {
            return
        }
        setImageToShow(imageToShow - 1)
    }

    const handleNextImage = () => {
        const imageToBeShown = imageToShow + 1

        if(selectedFilters['Mode'] === 'Review' && imageToShow === allImages.length-1){
            saveImageLabels()
            setPage(page+1)
            return
        }


       document.getElementById('nextImageArrow').classList.add('unclickable')

        if (imageToBeShown === allImages.length - 1 ) {
            document.getElementById('nextImageArrow').classList.add('hidden')
        }

        if(selectedFilters['Mode'] === 'Review' ){
            document.getElementById('nextImageArrow').classList.remove('unclickable')
            document.getElementById('nextImageArrow').classList.remove('hidden')
        }

        setImageToShow(imageToBeShown)

    }

    const handleSave = () => {

        authorizedHttpPost(urls.POST_LABELLED_IMAGES, {labels})
        .then((response)=>{
            setPage(page+1)
            removeSelections()
            setLabels([])
            setImageToShow(0)
            document.getElementById('nextImageArrow').classList.remove('hidden')
            return response
        })
        .then(console.log)
        .catch(console.log)
    }

    const saveImageLabels = ()=>{
        if (Object.keys(labels).length < 1) {
            flashMessage('Nothing to save....')
            return
        }


        authorizedHttpPost(urls.POST_LABELLED_IMAGES, {labels})
        .then((response)=>{
            setLabels([])
            flashMessage('Saved!')
            return response
        })
        .then(console.log)
        .catch(console.log)
    }

    const flashMessage = (message) => {
        const saved = document.getElementsByClassName('saved')[0]
        saved.classList.remove('hidden')
        saved.innerHTML = message
        setTimeout(()=>{
            saved.classList.add('hidden')
        }, 1000)
    }

    const handleSelection = (event) => {
        const id = event.target.id
        const value = event.target.getAttribute('value')
        const [label, selection] = id.split('_')

        if (!selection) {
            return
        }

        Array.from(document.getElementsByClassName(label)).forEach((element)=>{
            element.classList.remove('selectedRadioButton')
        })
        Array.from(document.getElementsByClassName(`selection${label}`)).forEach((element)=>{
            element.classList.add('hidden')
        })

        document.getElementById(id).classList.add('selectedRadioButton')
        document.getElementById(`selected${label}${selection}`).classList.remove('hidden')
        const imageLabels = {yes: false,neutral: false, no: false}

        const labelsToSet = {...labels, [allImages[imageToShow].id]: {...labels[allImages[imageToShow].id],[label]: {...imageLabels, [selection]: true}}}
        setLabels(labelsToSet)

        if (Object.keys(labelsToSet[allImages[imageToShow].id]).length === allLabels.length) {
            document.getElementById('nextImageArrow').classList.remove('unclickable')
        }
    }

    const setFilter = (event) => {
        const [filter, value, filterIndex] = event.target.getAttribute('value').split('_')
        setSelectedFilters({...selectedFilters, [filter]: value})
        handleFilter({target: {id: filterIndex}})
    }

    const handleSkip = () =>{
        setAllImages(allImages.filter((_, index) => index !== imageToShow))

        if(imageToShow === allImages.length - 1) {
            setLabels({...labels, [allImages[imageToShow].id]: false})
            setImageToShow(imageToShow - 1)
            return
        }

        setImageToShow(imageToShow)
        setLabels({...labels, [allImages[imageToShow].id]: false})
    }

    const handleStats = () =>{
        if (!stats || Object.keys(stats).length < 1) {
            flashMessage('No stats available')
            return
        }
        setStatsModal(true)
    }

    // return (<></>)

    return (
        <div className="App">
            {isLoading && <Loader />}
             <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'imageLabelling'}/>
             <div className="marginLeft200 marginTop25">
            <div className="labelWrapper">
            <div>
                {Object.keys(filters).length > 0 && <div className="filterBox">
                        {Object.keys(filters).map((filter, index)=>{
                            if ((['Category', 'Remarks', 'Mode'].includes(filter) ) && ['Curator', 'SeniorCurator', 'Associate'].includes(accessLevel)) { return null}
            
                            return <div className="filterWrapper">
                                {filter}
                                <div id={`filter${index}`} key={index} className="filter cursorPointer" onClick={handleFilter}>
                                {selectedFilters[filter]}
                                <img className={selectedFilter == `filter${index}` ? 'rotate' : 'rotateBack' } src={chevron_down}/>
                                </div>
                                {selectedFilter == `filter${index}` && (
                                <div className="dropdown">
                                    {filters[filter].map((_, i) => (
                                        <div className={`dropdown-item-wrapper cursorPointer ${i !== filters[filter].length - 1  ? 'dropdown-item-border-bottom' :''}`}>
                                            <div key={i} onClick={setFilter} value={`${filter}_${_}_filter${index}`} className="dropdown-item selectedItem">{_}</div>
                                        </div>
                                    ))}
                                </div>
                            )}
                            </div>
                        })}
                </div>}
                {allImages.length > 0 && <div className="imageViewer">
                    <img className="image" src={allImages[imageToShow].image_url} alt="placeholder" />
                    <p>Ref Id: {allImages[imageToShow].ref}</p>
                    <div className="photoNavigation">
                        <div className={`arrowBack cursorPointer ${imageToShow === 0 ? 'hidden':''}`} onClick={handlePreviousImage}><img src={arrow_back} alt="back" /></div>
                        <div id="nextImageArrow" className={`arrowForward cursorPointer ${selectedFilters['Mode'] === 'Label' ? 'unclickable' :''}`} onClick={handleNextImage}><img src={arrow_forward} alt="forward" /></div>
                    </div>
                    {selectedFilters["Mode"] === 'Label' ? <div className="stats cursorPointer" onClick={handleSkip}>Skip</div> : <div className="stats cursorPointer" onClick={handleStats}>Stats</div> }
                </div>}
                {/* <div className="stats cursorPointer">Stats</div> */}
            </div>
            <div className="tablesWrapper">
                <table className="labelTable">
                    <thead>
                        <tr>
                            <th></th>
                            <th className="header">Yes</th>
                            <th className="header">Neutral</th>
                            <th className="header">No</th>
                        </tr>
                    </thead>
                    <tbody>
                    {allLabels.map((label, index) => {
                            return (
                                <tr key={index}>
                                <td className="labelNameWrapper"><div className="labelName">{label}</div></td>
                                {['yes', 'neutral','no'].map((selection, i) => {
                                    if (!labelsWithNeutralOption.includes(label) && selection === 'neutral') return <td></td>
                                    return <td className="RadioButtonWrapper">
                                        <div onClick={handleSelection} id={`${label}_${selection}`} value={selection} className={`radioButton ${label}`}><div id={`selected${label}${selection}`} className={`selection selection${label} hidden`}>
                                    </div>
                                    </div>
                                    </td>
                                })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                {Object.keys(conflictedImages).length > 0 && <table className="conflictTable">
                    <thead>
                        <tr>
                            {
                                conflictedImages[String(allImages[imageToShow].id)].map((image) => {
                                    return (
                                        <td className="headerConflictTable">{image.curator_name}</td>
                                    )
                                })
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {allLabels.map((label) => {
                            return (
                            <tr>
                            {conflictedImages[String(allImages[imageToShow].id)].map((image) => {
                                const labelValue = image['labels'][label]
                                if (labelValue === undefined) { return <td></td>}
                                return (
                                    <td>{Object.keys(labelValue).filter(key => labelValue[key] === true)[0]}</td>
                                ) 
                            }) }
                            </tr>
                            )
                        })}
                    </tbody>
                </table>}
            </div>
            </div>
            {((imageToShow === allImages.length-1)) && <div onClick={handleSave} className="saveButton cursorPointer">Save</div>}
            <p className="saved hidden"></p>
            </div>
            {statsModal && <LabelStatsModal closeModal={()=>setStatsModal(false)} labels= {allLabels} stats={stats} />}
        </div>
    )
}